import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./StudentAttendance.css";

const API_ROOT     = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const COURSE_TYPES = [{ value: "1", label: "BDS" }, { value: "2", label: "MDS" }];
const getToday     = () => new Date().toISOString().slice(0, 10);

function cellColor(val) {
  if (!val) return "black";
  if (val === "P")  return "black";
  if (val === "A")  return "red";
  if (val === "HD") return "blue";
  if (val === "S")  return "brown";
  return "green";
}

export default function StudentMonthlyAttLeave() {
  const localUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); }
    catch { return null; }
  }, []);

  const moduleId = parseInt(localUser?.moduleId, 10);
  const isOfficeModule = moduleId === 4;
  const navigate = useNavigate();

  const [departments, setDepartments] = useState([]);
  const [form, setForm] = useState({
    selectedDate:       getToday(),
    selectedCourseType: "1",
    deptId:             "",
  });
  const [report,  setReport]  = useState(null);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");

  useEffect(() => {
    if (!isOfficeModule) return;
    fetch(`${API_ROOT}/api/students/departments?moduleId=${moduleId}`)
      .then(r => r.json())
      .then(data => Array.isArray(data) && setDepartments(data))
      .catch(() => {});
  }, [isOfficeModule, moduleId]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const onView = async (e) => {
    e.preventDefault();
    if (isOfficeModule && !form.deptId) { setError("Please select a Department."); return; }
    setError(""); setReport(null); setLoading(true);
    try {
      const params = new URLSearchParams({
        moduleId,
        selectedDate:       form.selectedDate,
        selectedCourseType: form.selectedCourseType,
        ...(isOfficeModule ? { deptId: form.deptId } : {}),
      });
      const res  = await fetch(`${API_ROOT}/api/students/monthly-att-leave?${params}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to load report");
      setReport(data.data);
    } catch (err) {
      setError(err.message || "Failed to load report");
    } finally {
      setLoading(false);
    }
  };

  if (![4, 5].includes(moduleId)) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-3">
      <h3 className="ctitle">Monthly Attendance Register (With Leave)</h3>

      <div className="mb-3 d-flex flex-wrap gap-2">
        <button type="button" className="btn btn-primary btn-sm" onClick={() => navigate("/student-attendance")}>
          Monthly Attendance(Time With Leave)
        </button>
        <button type="button" className="btn btn-secondary btn-sm" onClick={() => navigate("/student-ind-att")}>
          Individual Attendance
        </button>
        <button type="button" className="btn btn-info btn-sm" onClick={() => navigate("/student-monthly-att-raw")}>
          Monthly Attendance(Raw)
        </button>
        <button type="button" className="btn btn-warning btn-sm" onClick={() => navigate("/student-upload-att")}>
          Upload Attendance
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={onView} className="row g-2 align-items-end mb-3">
        {isOfficeModule && (
          <div className="col-auto">
            <label className="form-label mb-1">Department</label>
            <select
              className="form-select"
              name="deptId"
              value={form.deptId}
              onChange={onChange}
              required
            >
              <option value="">Select Department</option>
              {departments.map(d => (
                <option key={d.DepartmentID} value={d.DepartmentID}>{d.Department}</option>
              ))}
            </select>
          </div>
        )}

        <div className="col-auto">
          <label className="form-label mb-1">Select Month Date</label>
          <input
            className="form-control"
            type="date"
            name="selectedDate"
            value={form.selectedDate}
            onChange={onChange}
            required
          />
        </div>

        <div className="col-auto">
          <label className="form-label mb-1">Course Type</label>
          <select
            className="form-select"
            name="selectedCourseType"
            value={form.selectedCourseType}
            onChange={onChange}
          >
            {COURSE_TYPES.map(c => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>
        </div>

        <div className="col-auto">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Loading..." : "View"}
          </button>
        </div>
      </form>

      {report && (
        report.students.length === 0 ? (
          <div className="alert alert-info">No students found for the selected criteria.</div>
        ) : (
          <div className="table-responsive">
            <table className="stu-att-table">
              <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
                <tr>
                  <th colSpan={report.daysInMonth + 5}>
                    Monthly Attendance Report Of Student For The Month Of {report.monthName} - {report.year}
                  </th>
                </tr>
                <tr>
                  <th>SNo</th>
                  <th>Name</th>
                  {Array.from({ length: report.daysInMonth }, (_, i) => (
                    <th key={i}>{i + 1}</th>
                  ))}
                  <th>P</th>
                  <th>L</th>
                  <th>A</th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  {report.dayLetters.map((dl, i) => (
                    <th key={i}>{dl}</th>
                  ))}
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {report.students.map((stu, idx) => (
                  <React.Fragment key={stu.StudentID}>
                    <tr>
                      <td>{idx + 1}</td>
                      <td className="stu-name-cell">{stu.StudentName}</td>
                      {stu.timeIn.map((val, d) => (
                        <td key={d} style={{ color: cellColor(val) }}>{val}</td>
                      ))}
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td className="stu-name-cell">{stu.RollNo}</td>
                      {stu.timeOut.map((val, d) => (
                        <td key={d} style={{ color: cellColor(val) }}>{val}</td>
                      ))}
                      <td>{stu.summary.P}</td>
                      <td>{stu.summary.L}</td>
                      <td>{stu.summary.A}</td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}
